import React from 'react'
import ReactDOM from 'react-dom'

import '@/styles/index.css'
import App from './App'
import { ApolloProvider } from '@apollo/client'
import client from './apolo'

ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById('root')
)
